import './ContinueButton.css';
import flashImg from '../../components/atomic/buttons/button/flash.png';
import continueIconImg from './continue_icon.png';
import continueTextImg from './continue_text.png';

type ContinueButtonProps = {
  onClick?: () => void;
};

/** From Figma button_continue_delivery (137:300). */
export function ContinueButton({ onClick }: ContinueButtonProps) {
  return (
    <button
      type="button"
      className="pause-continue-button"
      aria-label="Продолжить"
      onClick={onClick}
    >
      <img
        className="pause-continue-button__flash"
        src={flashImg}
        alt=""
        draggable={false}
      />
      <img
        className="pause-continue-button__icon"
        src={continueIconImg}
        alt=""
        draggable={false}
      />
      <img
        className="pause-continue-button__text"
        src={continueTextImg}
        alt=""
        draggable={false}
      />
    </button>
  );
}
